module.exports = __webpack_public_path__ + "media/images/icon_list/sort_down-1e247c2e461e350cc2a905ac56aa726a.svg";